import React from 'react';

import i18n from '../../../../common/i18n';
import NegativeIcon from '../../../../icons/NegativeIcon';
import { closeRegistration } from './h&s';
import StepErrors from './StepErrors';
import { usePageUrl } from '../../../registration/hook/usePageUrl';

const StepRejected = () => {
    usePageUrl('/doregistracia/rejected');
    const child = (
        <div className="text-center" data-atid="rc-noCamera-actions-sendSms">
            <a className="nui-blue-link pointer text" href="/mapa-pobociek">
                {i18n('nui.button.branchesList')}
            </a>
        </div>
    );
    return (
        <StepErrors
            title={i18n('nui.documentsUpload.rejected.title')}
            subTitle={i18n('nui.documentsUpload.rejected.subtitle')}
            icon={<NegativeIcon fill="#00000033" />}
            buttonLabel={i18n('nui.button.close')}
            children={child}
            onClick={closeRegistration}
        />
    );
};

export default StepRejected;
